import { Refine } from "@refinedev/core";
import routerProvider from "@refinedev/react-router-v6";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

import { AuthGuard } from "@/components/auth-guard";
import { Layout } from "@/components/layout";
import { AppRunPage } from "@/pages/app-run";
import { BuilderPage } from "@/pages/builder";
import { CopilotPage } from "@/pages/copilot";
import { DashboardPage } from "@/pages/dashboard";
import { DataViewPage } from "@/pages/data-view";
import { GuidePage } from "@/pages/guide";
import { HomePage } from "@/pages/home";
import { AuthCallbackPage } from "@/pages/auth-callback";
import { LoginPage } from "@/pages/login";
import { MarketplacePage } from "@/pages/marketplace";
import { WorkflowsPage } from "@/pages/workflows";
import { authProvider } from "@/providers/auth-provider";
import { dataProvider } from "@/providers/data-provider";
import { RuntimeDataProvider } from "@/components/builder/runtime-data-provider";

function App() {
  return (
    <BrowserRouter>
      <Refine
        routerProvider={routerProvider}
        dataProvider={dataProvider}
        authProvider={authProvider}
        options={{
          syncWithLocation: true,
          warnWhenUnsavedChanges: true,
          useNewQueryKeys: true,
          projectId: "debug-pavilion",
        }}
      >
        <Routes>
          <Route
            element={
              <AuthGuard>
                <Layout>
                  <Outlet />
                </Layout>
              </AuthGuard>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="guide" element={<GuidePage />} />
            <Route path="builder" element={<RuntimeDataProvider><BuilderPage /></RuntimeDataProvider>} />
            <Route path="run/:appId/:pageId?" element={<AppRunPage />} />
            <Route path="copilot" element={<CopilotPage />} />
            <Route path="data" element={<DataViewPage />} />
            <Route path="marketplace" element={<MarketplacePage />} />
            <Route path="workflows" element={<WorkflowsPage />} />
          </Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
        </Routes>
      </Refine>
    </BrowserRouter>
  );
}

export default App;
